import './Participant.scss'
import moment from 'moment'
import SecurityService from '../../services/security.service'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import ParticipantResponsibleModal from './ParticipantResponsibleModal'

const ParticipantItem = ({ item, gender, removeParticipant }) => {
  const MySwal = withReactContent(Swal)

  function handleResponsibleInfoModal() {
    MySwal.fire({
      confirmButtonText: <span>OK</span>,
      customClass: {
        confirmButton: 'modal-confirm-button-class'
      },
      title: <span style={{ color: '#FFC107' }}>Dados do responsável</span>,
      html: <ParticipantResponsibleModal responsible={item.responsible} />
    })
  }

  return (
    <tr>
      <td>{item.name}</td>
      <td>{moment(item.born).format('DD/MM/YYYY')}</td>
      <td className='td-nickname'>{item.nickname}</td>
      <td>{gender}</td>
      <td>{item.favoriteColor}</td>
      <td>{item.favoritePet}</td>
      <td>{item.class}</td>
      <td>{item.IFAs}</td>
      <td>{item.powersParticipant.join(', ')}</td>
      <td>{item.missionParticipant.join(', ')}</td>
      <td>
        <button
          className='button-full responsible-btn'
          onClick={handleResponsibleInfoModal}
        >
          <i class='fas fa-external-link-alt' />
        </button>
      </td>
      <td>
        {SecurityService.isMaster() ? (
          <button
            className='ml-3 btn-remove'
            onClick={removeParticipant}
          >
            remover
          </button>
        ) : (
          <></>
        )}
      </td>
    </tr>
  )
}

export default ParticipantItem
